<template>
    <ProductDetailMediaGallery />
</template>

<script setup lang="ts">
import type { CmsElementImageGallery } from '@shopware/composables'

defineProps<{
    content: CmsElementImageGallery
}>()
</script>
